import { Navigate, Outlet } from "react-router-dom";
import { isLoggedIn } from "../hooks/useAuth";
import LanguageSwitcher from "../components/general/LanguageSwitcher";

/** Login/Register səhifələri — artıq daxil olubsa mağazalara yönləndir */
const AuthLayout = () => {
  if (isLoggedIn()) {
    return <Navigate to="/stores" replace />;
  }

  return (
    <div className="relative app-shell flex justify-center items-center bg-gradient-to-br from-indigo-600 via-purple-600 to-fuchsia-600 p-4">
      {/* Dil seçimi giriş ekranında da əlçatan olsun */}
      <div className="absolute top-4 right-4 z-10">
        <LanguageSwitcher />
      </div>
      <Outlet />
    </div>
  );
};

export default AuthLayout;
